module.exports = __webpack_public_path__ + "img/banner_search_2.6a40f693.png";